<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row :gutter="24">
        <el-form-item label="产品名称">
          <el-input
              v-model="serchParams.name"
              class="mb10"
              style="width: 240px"
              placeholder="请输入产品名称"
              clearable
          />
        </el-form-item>
        <el-form-item label="货品编码">
          <el-input
              v-model="serchParams.goodsCode"
              class="mb10"
              style="width: 240px"
              placeholder="请输入货品编码"
              clearable
          />
        </el-form-item>
        <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>

    <div class="d-flex" style="margin-bottom: 20px">
      <el-button class="ma" type="primary" @click="handleAddPageClass('add')">+添加产品</el-button>
    </div>

    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border>
      <el-table-column
          prop="name"
          align="center"
          label="名称"
      />
      <el-table-column
          prop="goodsCode"
          align="center"
          label="货品编码"
      >
        <template slot-scope="scope">
          {{ scope.row.goodsCode || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="standard"
          align="center"
          label="产品执行标准"
      >
        <template slot-scope="scope">

          {{ scope.row.standard || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="ingredient"
          align="center"
          label="成分"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.ingredient }}
        </template>
      </el-table-column>
      <el-table-column
          prop="traceIngredient"
          align="center"
          label="微量成分"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.traceIngredient }}
        </template>
      </el-table-column>
      <el-table-column
          prop="netContent"
          align="center"
          label="净含量"
      >
        <template slot-scope="scope">
          {{ scope.row.netContent || '--' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="specName"
          align="center"
          label="使用方法"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.useInfo }}
        </template>
      </el-table-column>
      <el-table-column
          prop="productionExplanation"
          align="center"
          label="产品名称相关解释说明"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.productionExplanation }}
        </template>
      </el-table-column>
      <el-table-column
          prop="innovation"
          align="center"
          label="创新用语"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.innovation }}
        </template>
      </el-table-column>
      <el-table-column
          prop="sort"
          align="center"
          label="排序"
      >
      </el-table-column>
      <el-table-column
          prop="sort"
          align="center"
          label="备案信息"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="showFiling(scope.row)">查看备案信息</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
          <el-button type="text" size="mini" @click="toLink(scope.row)">备案链接
          </el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                         @confirm="delPageClass(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>
    <addProduce ref="addPageClassDialog" @getList="getList"></addProduce>
    <el-dialog title="备案信息" :visible.sync="addFormVisible" append-to-body :close-on-click-modal="false">
      <!-- 查看模式：使用信息展示 -->
      <div class="detail-content">
        <div class="production-section">
          <div class="section-title">基本信息</div>
          <div class="detail-row">
            <span class="detail-label">备案信息名称：</span>
            <span class="detail-value">{{ addForm.name || '--' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">化妆品类型：</span>
            <span class="detail-value">{{
                addForm.type === 0 ? '普通化妆品' : addForm.type === 1 ? '特殊化妆品' : '--'
              }}</span>
          </div>
          <div class="detail-row" v-if="addForm.type === 1">
            <span class="detail-label">注册证书编号：</span>
            <span class="detail-value">{{ addForm.certificateNo || '--' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">注册人/备案人国籍：</span>
            <span class="detail-value">{{ addForm.isChina == 1 ? '中国' : addForm.isChina == 0 ? '外国' : '--' }}</span>
          </div>
          <div class="detail-row" v-if="addForm.type === 1">
            <span class="detail-label">注册人中文名称：</span>
            <span class="detail-value">{{ addForm.filingPerson || '--' }}</span>
          </div>
          <div class="detail-row" v-if="addForm.type === 1">
            <span class="detail-label">注册人住所：</span>
            <span class="detail-value">{{ addForm.filingPersonAddress || '--' }}</span>
          </div>
          <div class="detail-row" v-if="addForm.type === 0">
            <span class="detail-label">备案人中文名称：</span>
            <span class="detail-value">{{ addForm.filingPerson || '--' }}</span>
          </div>
          <div class="detail-row" v-if="addForm.type === 0">
            <span class="detail-label">备案人住所：</span>
            <span class="detail-value">{{ addForm.filingPersonAddress || '--' }}</span>
          </div>
          <div class="detail-row" v-if="addForm.isChina == 0">
            <span class="detail-label">境内责任人名称：</span>
            <span class="detail-value">{{ addForm.chinaLeader || '--' }}</span>
          </div>
          <div class="detail-row" v-if="addForm.isChina == 0">
            <span class="detail-label">境内责任人住所地址：</span>
            <span class="detail-value">{{ addForm.chinaLeaderAddress || '--' }}</span>
          </div>
        </div>

        <!-- 生产企业信息（支持多组） -->
        <div class="production-section">
          <div class="section-title">生产企业信息</div>
          <div v-for="(production, index) in addForm.productionList" :key="index" class="production-item">
            <el-card class="production-card">
              <div slot="header" class="clearfix">
                <span>生产企业 {{ index + 1 }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">生产企业名称：</span>
                <span class="detail-value">{{ production.productionCompany || '--' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">生产企业住所地址：</span>
                <span class="detail-value">{{ production.productionCompanyAddress || '--' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">生产地址：</span>
                <span class="detail-value">{{ production.productionAddress || '--' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">生产许可证编号：</span>
                <span class="detail-value">{{ production.productionLicense || '--' }}</span>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </el-dialog>


    <!--    <el-dialog title="备案链接" :visible.sync="linkDialogVisible" width="500px" @open="initClipboard" @close="destroyClipboard" append-to-body>-->
    <!--      <div class="link-dialog-content">-->
    <!--        &lt;!&ndash; 给 clipboard 绑定元素增加 id，方便获取 &ndash;&gt;-->
    <!--        <span id="copyLinkTarget" class="tag-read" :data-clipboard-text="handleLink" style="display: none;"></span>-->
    <!--        <div class="link-text">{{ handleLink || '暂无备案链接' }}</div>-->
    <!--        <el-button type="primary" class="copy-btn" @click="copyLink()">复制</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->

    <el-dialog
        title="备案链接"
        :visible.sync="linkDialogVisible"
        width="580px"
        @open="initClipboard"
        @close="destroyClipboard"
        :close-on-click-modal="false"
        class="link-dialog"
        center
        append-to-body
    >
      <div class="link-dialog-content">
        <!-- 链接展示区域 -->
        <div class="link-display-wrapper">
          <label class="link-label">备案链接：</label>
          <div
              class="link-text"
              :class="{ 'empty-link': !handleLink }"
          >
            {{ handleLink || '暂无可用的备案链接' }}
          </div>
        </div>

        <!-- 复制按钮区域 -->
        <div class="copy-btn-wrapper">
          <el-button
              type="primary"
              class="copy-btn"
              @click="copyLink()"
              :disabled="!handleLink"
              icon="el-icon-copy-document"
          >
            复制链接
          </el-button>
        </div>

        <!-- 隐藏的clipboard目标元素 -->
        <span
            id="copyLinkTarget"
            class="tag-read"
            :data-clipboard-text="handleLink"
            style="display: none;"
        ></span>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import addProduce from "./components/addProduce.vue";
import {
  deleteCustomPageClass,
  pageClassList,
  noPage,
  fetchClassPage,
  fetchEnableClass,
  hzpLink
} from '@/api/customPageClass.js'
import {selectAllCategory} from "@/api/productCategory";
import {selectFilingDetail} from '@/api/hzpFilingInfo.js'
import Clipboard from 'clipboard'

export default {
  components: {
    // commonTable,
    // AddPageClassDialog,
    addProduce
    // customPopconfirm
  },
  props: {
    classType: {
      default: 0
    }
  },
  data() {
    return {
      name: null,
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      parentName: '',
      treeProps: {
        children: 'children',
        label: 'name'
      },
      expandOnClickNode: false,
      classList: [],
      categoryId: '',
      serchParams: {
        name: '',
        categoryId: '',
        goodsCode: ''
      },
      addForm: '',
      addFormVisible: false,
      handleLink: undefined,
      clipboardInstance: undefined,
      linkDialogVisible: false
    };
  },
  created() {
    this.getList()
    this.getCategorys()
  },
  methods: {
    initClipboard() {
      // 先销毁已有实例
      this.destroyClipboard()
      // 初始化新实例
      this.clipboardInstance = new Clipboard('#copyLinkTarget')
      // 监听复制成功事件
      this.clipboardInstance.on('success', (e) => {
        this.$message.success('链接复制成功！')
        // 清除选中的文本，提升体验
        e.clearSelection()
      })

      // 监听复制失败事件
      this.clipboardInstance.on('error', () => {
        this.$message.error('复制失败，请手动复制链接！')
      })
    },

    // 销毁 clipboard 实例
    destroyClipboard() {
      console.log('销毁 clipboard 实例')
      if (this.clipboardInstance) {
        this.clipboardInstance.destroy()
        this.clipboardInstance = null
      }
    },

    // 备案链接弹窗触发
    toLink(row) {
      hzpLink({classId: row.id}).then(res => {
        if(res.code === 200){
          this.handleLink = res.data || ''
          this.linkDialogVisible = true
        }else if(res.code === 500){
          this.$message.error(res.message)
        }

      }).catch(err => {
        console.error('获取备案链接失败：', err)
        this.$message.error('获取备案链接失败，请重试！')
      })
    },

    // 复制链接方法
    copyLink() {
      // 校验链接是否存在
      if (!this.handleLink) {
        this.$message.warning('暂无可复制的备案链接！')
        return
      }
      // 触发 clipboard 复制
      const target = document.getElementById('copyLinkTarget')
      if (target) {
        target.click()
      } else {
        // 降级方案：手动复制
        const input = document.createElement('input')
        input.value = this.handleLink
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        // this.$message.success('链接复制成功！')
      }
    },
    truncateText(text, maxLength) {
      if (!text) return '--';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    showFiling(row) {
      selectFilingDetail({id: row.filingId}).then(res => {
        this.addForm = res.data
        if (this.addForm.productionCompany) {
          this.addForm.productionList = JSON.parse(this.addForm.productionCompany)
        }
        this.addFormVisible = true
      })
    },
    enabledClass(row) {
      fetchEnableClass({id: row.id}).then(res => {
        this.$message.success("操作成功")
        this.getList()
      })
    },
    resetSearch() {
      this.serchParams.name = ''
      this.serchParams.categoryId = ''
      this.parentName = ''
      this.serchParams.goodsCode = ''
      this.pageNum = 1
      this.getList()
    },
    getCategorys() {
      selectAllCategory().then(res => {
        this.classList = res.data
      })
    },
    handleNodeClick(node) {
      this.serchParams.categoryId = node.id
      this.parentName = node.fullName
      this.$refs.selectTree.blur();
    },
    setValueNull() {
      this.ruleForm.parentId = '';
      this.parentName = ''
    },
    optionData(array, result = []) {
      array.forEach(item => {
        result.push({
          label: item.fullName,
          value: item.id
        })
        if (item.children && item.children.length !== 0) {
          this.optionData(item.children, result)
        }
      })
      return JSON.parse(JSON.stringify(result))
    },
    getCustomer() {
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddPageClass(type, id) {
      this.$refs.addPageClassDialog.openDialog(type, id, this.classType, true)
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.classType,
        isHzp: true
      }
      Object.assign(params, this.serchParams)
      fetchClassPage(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    editCustomer(data) {
      this.$refs.addPageClassDialog.openDialog('edit', data, this.classType, true)
    },
    delPageClass(data) {
      console.log(data)
      deleteCustomPageClass(data.id).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.getList()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },
    lookImg(row) {
      this.$router.push({
        path: '/classImgList', query: {
          id: row.id,
          name: row.name,
        },
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}

.pageBox {
  display: flex;
  justify-content: flex-end;
}

.text-color-red {
  color: #fd634e;
}

.text-color-green {
  color: #74d7d5;
}

.detail-content .detail-row {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.5;
}

.detail-content .detail-row:last-child {
  margin-bottom: 0;
}

.detail-content .detail-label {
  width: 148px;
  flex-shrink: 0;
  color: #606266;
  font-size: 14px;
}

.detail-content .detail-value {
  flex: 1;
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}

/* 生产企业样式 */
.production-section {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.production-item {
  margin-bottom: 15px;
}

.production-card {
  border: 1px solid #ebeef5;
}

.production-card:last-child {
  margin-bottom: 0;
}

.link-dialog ::v-deep .el-dialog__header {
  border-bottom: 1px solid #e8eaec;
  padding: 16px 20px;
  margin-bottom: 0;
}

.link-dialog ::v-deep .el-dialog__header .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.link-dialog ::v-deep .el-dialog__header .el-dialog__headerbtn {
  top: 18px;
}

.link-dialog ::v-deep .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
  color: #666;
}

.link-dialog ::v-deep .el-dialog__header .el-dialog__headerbtn .el-dialog__close:hover {
  color: #409eff;
}

.link-dialog ::v-deep .el-dialog__body {
  padding: 24px 20px;
  background-color: #f9fafb;
}

.link-dialog ::v-deep .el-dialog__footer {
  padding: 16px 20px;
  border-top: 1px solid #e8eaec;
  text-align: center;
}

/* 弹窗内容容器 */
.link-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 链接展示区域 */
.link-display-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.link-display-wrapper .link-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.link-display-wrapper .link-text {
  width: 100%;
  padding: 16px 12px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  color: #303133;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-all;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;
}

/* 空链接样式 */
.link-display-wrapper .link-text.empty-link {
  color: #909399;
  border-style: dashed;
  background-color: #fefefe;
}

.link-display-wrapper .link-text:hover {
  border-color: #c0c4cc;
}

/* 复制按钮区域 */
.copy-btn-wrapper {
  display: flex;
  justify-content: center;
}

.copy-btn-wrapper .copy-btn {
  min-width: 120px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  background-color: #409eff;
  border-color: #409eff;
}

.copy-btn-wrapper .copy-btn:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.copy-btn-wrapper .copy-btn:disabled {
  background-color: #c6e2ff;
  border-color: #c6e2ff;
  cursor: not-allowed;
}
</style>

